import script from "./StepEditorModal.vue?vue&type=script&setup=true&lang=js"
export * from "./StepEditorModal.vue?vue&type=script&setup=true&lang=js"

import "./StepEditorModal.vue?vue&type=style&index=0&id=35a520ec&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35a520ec"]])

export default __exports__